/**
 * Кто держит слой рукой прямо сейчас.
 *
 * ЧТО ЭТО. Модератор, начавший перетаскивание, берёт слой в
 * монопольное пользование — лизу, — и hub рассказывает об этом всей
 * комнате: панелям, чтобы погасить кнопки чужого слоя, и оверлею.
 *
 * ЗАЧЕМ ЭТО ОВЕРЛЕЮ. Слой, припаркованный за краем кадра, в эфире
 * не смонтирован: узла нет, картинка не декодирована. Внесённый
 * рывком, он создаётся ровно в миг пересечения границы — и зритель
 * видит, как он догоняет курсор. Взятие руки говорит об этом
 * заранее: слой ещё за кадром, но уже понятно, что он туда едет.
 *
 * Разбор общий, как у стоп-крана: панель читает те же сообщения,
 * и две реализации разошлись бы молча.
 */
import { decodeMessage } from './message.js';
/**
 * Разбирает сообщение `lease`.
 *
 * Возвращает `null`, если сообщение не о лизе: вызывающий отличает
 * «не моё» от «отпустили».
 */
export function parseLease(raw) {
    const message = decodeMessage(raw);
    if (message === null || message.t !== 'lease')
        return null;
    const layerId = message.layerId;
    if (typeof layerId !== 'string' || layerId === '')
        return null;
    // Пустой держатель — это ОТВЕТ «свободен», а не отсутствие ответа:
    // так снятие лизы и приходит
    return { layerId, held: decodeMessage(message.holder) !== null };
}
//# sourceMappingURL=lease.js.map